import { TYPES } from '../action';
import { fiveGsaInitialState } from '../state';

export default function fiveGsaReducer(state = fiveGsaInitialState, action) {
  switch (action.type) {
    case TYPES.SET_FIVE_GSA_INIT_DATA:
      return Object.assign({}, state, { initData: action.payload });
    case TYPES.CLEAR_FIVE_GSA_INIT_DATA:
      return Object.assign({}, state, { initData: null });
    default:
      return state;
  }
}
